import React, { useState, useEffect, useRef } from 'react';
import '../Estilos/Fontes.css';
import '../Estilos/SelectInput.css';
import '../Estilos/Dropdown.css';
import SwitchComponente from '../Componentes/SwitchComponente';

function SelectInput({
  titulo,
  largura = '100%',
  top = 0,
  bottom = 0,
  right = 0,
  clicado,
  itens = [],
  padrao,
  disabled = false,
  erro = false,
  erroTexto = '',
  enableSwitch = false,
  handleSwitchChange,
  defaultSwitchValue = false,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(padrao);
  const containerRef = useRef(null);

  useEffect(() => {
    if (padrao !== selectedOption) {
      setSelectedOption(padrao);
    }
  }, [padrao]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const toggleDropdownVisibility = () => {
    if (!disabled) {
      setIsVisible(prev => !prev);
    }
  };

  const handleOptionClick = (item, event) => {
    event.stopPropagation();
    if (!disabled) {
      clicado(item);
    }
    setIsVisible(false);
  };

  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: largura,
        marginTop: top,
        marginBottom: bottom,
        marginRight: right,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <h5 id='TituloInput'>{titulo}</h5>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
        <div className="SelectContainer" style={{ width: '100%' }} onClick={toggleDropdownVisibility}>
          <h5 className="FonteSelectPadrao">{selectedOption.label}</h5>
          <img src={require('../Icones/setinhaSelect.svg').default} alt="" />
        </div>
      { enableSwitch && <SwitchComponente status={defaultSwitchValue} onChange={(event) => handleSwitchChange(event)}/> }
      </div>

      {isVisible && (
        <div className="ItensSelect">
          {itens !== null && itens.length !== 0 && itens.map((item) => (
            <h1 key={item.value} className="FonteSelect" onClick={(event) => handleOptionClick(item, event)}>
              {item.label}
            </h1>
          ))}
        </div>
      )}

      {erro && (
        <div
          style={{
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingTop: 8,
          }}
        >
          <img src={require('../Icones/block.svg').default} alt="block" />
          <h4
            style={{
              color: 'red',
              fontSize: 12,
              padding: 0,
              margin: 0,
              verticalAlign: 'center',
              paddingLeft: 8,
              fontFamily: 'montserrat',
              fontWeight: 500,
            }}
          >
            {erroTexto}
          </h4>
        </div>
      )}
    </div>
  );
}

export default SelectInput;
